import { type MatrixEvent, M_BEACON_INFO } from "matrix-js-sdk/src/matrix";

/**
 * beacon_info events without live property set to true
 * should be displayed in the timeline
 */
export const shouldDisplayAsBeaconTile = (event: MatrixEvent): boolean =>
    M_BEACON_INFO.matches(event.getType()) &&
    (event.getContent()?.live ||
        // redacted beacons should show 'message deleted' tile
        event.isRedacted());
